<template>
    <div class="h-3 flex items-center">
        <div class="h-2 flex-1 relative bg-gray-500 rounded cursor-pointer" ref="track">
            <div v-for="pipPosition in pipPositions"
                :key="pipPosition"
                class="bg-white w-2 h-full absolute top-0"
                :style="{ left: (pipPosition * 100) + '%' }"
            />
            <div class="h-full bg-blue-300 rounded" :style="{ width: (fraction * 100) + '%' }" />
            <div class="reel-scrubber-ball absolute bg-white w-5 h-5 rounded-full z-10" :style="{ left: `${fraction * 100}%` }" />
        </div>
    </div>
</template>

<script>
    import range from 'lodash/range'
    import { mapGetters, mapState, mapActions } from '@/utils/namespaced-mappings'

    export default {
        props: {
            namespace: { type: String, required: true },
        },

        data() {
            return {
                mouseDownHandler: null,
                mouseUpHandler: null,
                mouseMoveHandler: null,
            }
        },

        computed: {
            ...mapGetters(['absoluteTime', 'totalOverallTime']),
            ...mapGetters({ clips: 'clipsInPlayOrder' }),

            fraction() {
                return this.absoluteTime / this.totalOverallTime
            },

            pipPositions() {
                const pips = []
                let total = 0

                for (const clip of this.clips) {
                    if (total != 0) {
                        pips.push(total / this.totalOverallTime)
                    }

                    const startTime = clip.start_time || 0
                    const endTime = clip.end_time || clip.video.durationInMilliseconds || clip.video.duration
                    const duration = endTime - startTime

                    total += duration
                }

                return pips
            }
        },

        mounted() {
            $(this.$refs.track).on('mousedown touchstart', this.mouseDownHandler = e => {
                this.jumpAndStartDragging(e)
            })

            $(document).on('mouseup touchend', this.mouseUpHandler = e => {
                this.dragging = false
            })

            $(document).on('mousemove touchmove', this.mouseMoveHandler = e => {
                const clientX = e.type === 'touchmove'
                    ? e.originalEvent.changedTouches[0].clientX
                    : e.clientX

                if (this.dragging) {
                    this.updateDragging(clientX - this.$refs.track.getBoundingClientRect().left)
                }
            })
        },

        beforeDestroy() {
            $(document).off('mousedown touchstart', this.mouseDownHandler)
            $(document).off('mouseup touchend', this.mouseUpHandler)
            $(document).off('mousemove touchmove', this.mouseMoveHandler)
        },

        methods: {
            ...mapActions(['jumpToAbsoluteTime']),

            jumpAndStartDragging(e) {
                const clientX = e.type === 'touchstart'
                    ? e.originalEvent.changedTouches[0].clientX
                    : e.clientX

                this.dragging = true
                this.updateDragging(clientX - this.$refs.track.getBoundingClientRect().left)
            },

            startDragging() {
                this.dragging = true
            },

            updateDragging(offsetX) {
                const fraction = offsetX / this.$refs.track.offsetWidth
                this.scrubTo(fraction)
            },

            scrubTo(fraction) {
                this.jumpToAbsoluteTime(fraction * this.totalOverallTime)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .reel-scrubber-ball {
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>